<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading">
  <div class="my-5 mt-0 dark:bg-blacks">
    <h2 class="text-lg font-semibold mb-3 mr-5 ml-0 dark:text-[#FFFFFF]">
      Dashboard
    </h2>
    <div class="flex space-x-4">
      <div class="bg-white shadow-md rounded-lg p-6 text-center border dark:bg-[#363636]">
        <h3 class="text-sm font-medium text-gray-500 dark:text-white">
          Total DIO
        </h3>
        <p class="text-2xl font-bold text-black mt-2 dark:text-white">{{ dioCount }}</p>
      </div>
    </div>
  </div>

  <div class="w-full px-10 py-7 bg-tileLight dark:bg-[#363636] shadow-lg rounded-xl">
    <div class="flex flex-row items-center justify-between mb-8">
      <h2 class="text-lg font-semibold mb-4 dark:text-white">Dispatch Rate</h2>
    </div>
    <div>
      <div class="bg-[#FFFFFF] dark:bg-[#363638] p-5 rounded-lg text-center text-[#888888] dark:text-[#FFFFFF]">
        <div class="chart-container" style="position: relative; height: 400px; width: 100%">
          <canvas id="MyChart"></canvas>
        </div>
      </div>
    </div>
  </div>
</div>